'use client';

import { MovableModal } from '@flipster/features/src/shared/movable-modal';
import { ModalErrorBoundary } from '@flipster/features/src/utils/modal-error-boundary';
import { FormattedMessage } from '@flipster/i18n';

import InstantFlipContent from './InstantFlipContent';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onExit?: () => void;
}

const InstantFlipModal = ({ isOpen, onClose, onExit }: Props) => {
  return (
    <MovableModal.Root isOpen={isOpen} onClose={onClose} onExit={onExit}>
      <MovableModal.Header>
        <MovableModal.Title label={<FormattedMessage id='Position_flip.r250401.Instant_flip' />} />
      </MovableModal.Header>
      <ModalErrorBoundary onError={onClose}>
        <InstantFlipContent onFinish={onClose} />
      </ModalErrorBoundary>
    </MovableModal.Root>
  );
};

export default InstantFlipModal;
